export const obtenerValorPedido = (arr=[]) =>{

    let valor = 0
    for (let i=0; i<arr.length; i++){
        let prod = arr[i];

        valor += parseInt(prod.cantidad) * parseInt(prod.valor)


    }

    return valor

}